const state = new Map();

export default state;
